<template>
  <div>
    <div v-if="page_loading">
      <mtd-loading style="padding-top: calc(100vh * 0.45)" :loading="page_loading" size="large"/>
    </div>
    <div v-if="!page_loading">
      <mtd-header height="48px">
        <div class="title">数据安全运营平台</div>
        <div class="user-name" style="margin-right: 10px;">
          <mtd-dropdown trigger="hover">
            <mtd-button type="text" style="padding:0;width:22px; min-width: 22px;">
              <img class="user-name-img" :src="login_user.avatar">
            </mtd-button>
            <mtd-dropdown-menu slot="dropdown" class="platform-user-dropdown">
              <mtd-dropdown-menu-item>
                <div class="platform-user-info">
                  <img class="platform-user-img" :src="login_user.avatar">
                  <span class="platform-user-name">{{login_user.username}}</span>
                  <span class="platform-user-name">{{login_user.mis_id}}</span>
                </div>
              </mtd-dropdown-menu-item>
              <mtd-dropdown-menu-item>
                <div style="padding: 4px 12px; color: rgba(0, 0, 0, 0.84);">
                  <mtd-button type="text" icon="mtdicon mtdicon-log-out" @click="logout">退出</mtd-button>
                </div>
              </mtd-dropdown-menu-item>
            </mtd-dropdown-menu>
          </mtd-dropdown>
        </div>
      </mtd-header>
      <div v-if="!is_mobile" class="total-content">
        <mtd-row type="flex" class="row-bg" justify="center" v-if="!submit_flag">
          <mtd-col :span="8" style="text-align: center;margin-bottom: 32px">
            <img src="../../../public/edit.png" style="width: 134px;height: 128px">
          </mtd-col>
        </mtd-row>
        <mtd-row type="flex" class="row-bg" justify="center" v-if="submit_flag">
          <mtd-col :span="8" style="text-align: center;margin-bottom: 32px">
            <img src="../../../public/timing.png" style="width: 100px;height: 100px">
          </mtd-col>
        </mtd-row>
        <mtd-row type="flex" class="row-bg" justify="center" v-if="errorCommands">
          <mtd-col :span="6">
            <div class="total-content">
              <div style="text-align: center;font-size: 100px;color: rgb(245, 72, 59)">
                <mtd-icon name='error-o'></mtd-icon>
              </div>
              <div class="tooltip-text">
                该文档无需申诉，请重新确认
              </div>
            </div>
          </mtd-col>
        </mtd-row>
        <mtd-row type="flex" class="row-bg" justify="center" v-else>
          <mtd-col :xl="12" :lg="12" :md="18" :sm="22" :xs="22">
            <div>
              <div class="tooltip-text" v-if="(submit_form.sourceApplication !== 'XM' || submit_flag) && show_text">
                <span v-html="tips"></span>
              </div>
              <div class="tooltip-text" v-if="!show_text">
                <template>
                  <mtd-loading message="正在加载数据，请稍后..."/>
                </template>
              </div>
              <div style="width: 100%">
                <mtd-steps :active="0" :space="100" v-if="!is_mobile" style="justify-content: center;">
                  <mtd-step :title="item.approvalName" :description="formatUserData(item.users)"
                            v-for="(item,index) in chains" :key="index"/>
                </mtd-steps>
              </div>
              <div v-if="!submit_flag">
                <div style="margin-top: 30px;text-align: center;">
                  <mtd-textarea placeholder="请详细填写申请原因，申请更容易通过（必填）"
                                v-model="submit_form.reason" style="width: 480px;"
                                rows="3"/>
                </div>
                <div style="margin-top: 32px;text-align: center">
                  <mtd-button type="primary" @click="submit" :loading="submit_loading"
                              :disabled="submit_form.reason.trim() === ''" size="large">
                    提交申请
                  </mtd-button>
                </div>
              </div>
              <div v-else>
                <div style="margin-top: 94px;text-align: center">
                  <mtd-button size="large" @click="toShenpi">审批详情</mtd-button>
                </div>
              </div>
            </div>
          </mtd-col>
        </mtd-row>
      </div>
      <div v-if="is_mobile" class="mobile-container" style="padding: 6px 8px">
        <mtd-form label-position="top">
          <div>
            <mtd-announcement v-if="show_text"
                              :title="tips"
                              type="warning"
                              show-icon/>
            <div class="tooltip-mobile" v-if="!show_text">
              <template>
                <mtd-loading message="正在加载数据，请稍后..."/>
              </template>
            </div>
          </div>
          <div style="margin-top: 6px;border-radius: 12px;background-color: #FFFFFF;padding: 8px 8px" v-if="!submit_flag">
            <mtd-form-item label="申请原因" class="mtd-form-item-required">
              <mtd-textarea placeholder="请详细填写申请原因，申请更容易通过（必填）"
                            v-model="submit_form.reason" style="width: 100%;"
                            rows="5"/>
            </mtd-form-item>
          </div>
          <div v-if="submit_flag" style="margin-top: 6px;border-radius: 12px;background-color: #FFFFFF;padding: 8px 8px">
            <div class="shenpi-icon">
              <mtd-icon name='time'></mtd-icon>
            </div>
            <div class="shenpi-text">
              已经发起审批, 如果长时间未反馈，可大象联系审批人进入审批详情页催办
            </div>
          </div>
          <div style="margin-top: 8px;text-align: center;" v-if="submit_flag">
            <mtd-button style="width: 95%;border-radius: 8px" size="large" @click="toShenpi">
              <span>审批详情</span>
            </mtd-button>
          </div>
          <div style="margin-top: 8px;border-radius: 12px;background-color: #FFFFFF;padding: 8px 8px">
            <div class="complaint-title">
              申诉流程
            </div>
            <mtd-steps :active="0" direction="vertical" :space="80">
              <mtd-step
                :title="item.approvalName"
                :description="formatUserData(item.users)"
                v-for="(item,index) in chains" :key="index"/>
            </mtd-steps>
          </div>
          <div style="margin-top: 12px;align-items: center;height: 80px" v-if="!submit_flag">
            <mtd-row type="flex" justify="center">
              <mtd-col :span="20">
                <mtd-button class="btn-demo-item" type="primary" style="width: 100%"
                            @click="submit"
                            :loading="submit_loading" :disabled="submit_form.reason.trim() === ''">提交
                </mtd-button>
              </mtd-col>
            </mtd-row>
          </div>
        </mtd-form>
      </div>
    </div>
  </div>
</template>

<script>

  import moment from 'moment';
  import {mapActions} from 'vuex'
  import sso from '@/utils/sso'

  export default {
    name: "complaint",
    filters: {
      dateTimeFormat(dateTime) {
        if (dateTime) {
          return moment(dateTime)
            .utcOffset(480)
            .format('YYYY-MM-DD HH:mm:ss');
        } else {
          return "";
        }
      },
    },
    data() {
      return {
        submit_form: {
          reason: '',
          misId: '',
          contentId: '',
          command: '',
          type: '',
          sourceApplication: null,
          strategyId: null,
          sensitiveWord: null,
          sourceType: null,
          deviceType: null,
          osType: null,
          addInf: null
        },
        chains: [],
        tips: '',
        errorCommands: false,
        submit_flag: false,
        show_text: false,
        url: '',
        submit_loading: false,
        is_mobile: false,
        page_loading: true
      }
    },
    mounted: function () {
      this.isMobile();
      // 获取参数信息
      this.submit_form.misId = this.$route.query.misId;
      this.submit_form.contentId = this.$route.query.contentId;
      this.submit_form.command = this.$route.query.commands;
      this.submit_form.sensitiveWord = this.$route.query.sensitiveWord
      this.submit_form.addInf = this.$route.query.addInf
      // 获取页面配置信息

      // 新添加兼容大象、学城的场景
      let {commands, contentId, system, fileInstanceId, sourceType, deviceType, osType, sensitiveWord, fileId, appId, fileItemId} = this.$route.query;
      // 学城文档和大象文件分开进行
      if (fileId && appId && system && system.toLocaleLowerCase() === 'diego') {
        // 文件中台下载
        this.submit_form.contentId = fileId;
        this.submit_form.fileInstanceId = fileId;
        this.submit_form.appId = appId;
        this.submit_form.fileItemId = fileItemId;
        this.submit_form.sourceApplication = 'DIEGO';
        this.submit_form.sourceType = sourceType;
        this.submit_form.deviceType = deviceType;
        this.submit_form.osType = osType;
        this.submit_form.strategyId = commands;
      } else if (fileInstanceId && fileInstanceId !== '' && (!system || (system && system.toLowerCase() !== 'km'))) {
        // 大象下载
        this.submit_form.contentId = fileInstanceId;
        this.submit_form.strategyId = commands;
        this.submit_form.sourceApplication = "XM";
        this.submit_form.sensitiveWord = sensitiveWord;
        this.submit_form.sourceType = sourceType;
        this.submit_form.deviceType = deviceType;
        this.submit_form.osType = osType;
      }  else if (system && system.toLocaleLowerCase() === 'km' && sensitiveWord) {
        //关键词禁搜
        this.submit_form.strategyId = commands;
        this.submit_form.sourceApplication = "SEARCH";
        this.submit_form.sensitiveWord = sensitiveWord;
        this.submit_form.sourceType = sourceType;
        this.submit_form.deviceType = deviceType;
        this.submit_form.osType = osType;
        //学城和反爬
      } else if (system && system.toLowerCase() === 'km') {
        // 学城文档或学城附件
        if (fileInstanceId) {
          this.submit_form.contentId = fileInstanceId;
          this.submit_form.fileInstanceId = contentId;
          this.submit_form.sourceApplication = "KM_ATTACHMENT";
          this.submit_form.deviceType = deviceType;
          this.submit_form.osType = osType;
        } else {
          this.submit_form.contentId = contentId;
          this.submit_form.sourceApplication = "KM";
          this.submit_form.sensitiveWord = sensitiveWord;
        }
        this.submit_form.strategyId = commands;
      // zeus
      } else if (system && system.toLowerCase() === 'fp') {
        // 反爬，来自于统一安全拦截页
        this.submit_form.strategyId = commands;
        this.submit_form.sourceApplication = "FACTOR";
      } else if (system && system.toLowerCase() === 'iam') {
        this.submit_form.strategyId = commands;
        this.submit_form.sourceApplication = "IAM";
      } else if (system && system.toLowerCase() === 'wenshu') {
        this.submit_form.strategyId = commands;
        this.submit_form.sourceApplication = "WENSHU";
      } else {
        // zeus
        this.submit_form.strategyId = commands;
        this.submit_form.sourceApplication = "ZEUS";
      }
      this.getPageInfo();
    },

    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
      formatUserData() {
        return function (userList) {
          let users = '';
          for (let i = 0; i < userList.length; i++) {
            let user = userList[i].accountName + "/" + userList[i].mis;
            users += user;
            if (i !== userList.length - 1) {
              users += '、'
            }
          }
          return users;
        };
      }
    },
    methods: {
      ...mapActions([
        'api_create_complaint',
        'api_get_page_info'
      ]),
      getPageInfo() {
        this.api_get_page_info(this.submit_form).then(res => {
          const param = res.data;
          if (param.reminderId) {
            if (sso.isProd()) {
              window.location.href = 'https://operation.sankuai.com/#/alarm/' + param.reminderId;
            } else {
              window.location.href = 'https://tjt.sec.test.sankuai.com/#/alarm/' + param.reminderId;
            }
          } else {
            this.page_loading = false;
            this.chains = res.data.approvalChain;
            this.tips = res.data.tips;
            this.show_text = true;
            this.submit_form.command = res.data.command;
            this.submit_form.strategyId = res.data.strategyId;
            this.submit_form.sourceApplication = res.data.sourceApplication;
            if (param.url != null && param.url !== '') {
              this.submit_flag = true;
              this.tips = this.submit_form.sourceApplication === 'XM' ? "申请提交成功" : "已经发起审批，如果长时间未反馈，可大象联系审批人进入审批详情页催办";
              this.url = param.url;
            }
          }
        });
      },
      toShenpi() {
        window.open(this.url, '_blank');
      },
      logout() {
        sso.logout();
      },
      submit() {
        let vm = this;
        vm.submit_loading = true;

        this.api_create_complaint(vm.submit_form).then(res => {
          if (res.code === 0) {
            vm.$mtd.message.success("提交成功");
            this.url = res.data;
            this.submit_flag = true;
            this.tips = this.submit_form.sourceApplication === 'XM' ? "申请提交成功" : "已经发起审批，如果长时间未反馈，可大象联系审批人进入审批详情页催办";
          } else if (res.code === 400) {
            vm.$mtd.message.error(res.message);
          } else {
            vm.$mtd.message.error("提交失败");
          }
        }).finally(() => {
          vm.submit_loading = false;
        });
      },
      isMobile() {
        this.flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if (this.flag !== null) {
          this.is_mobile = true;
        }
      }
    }
  }
</script>

<style>
  @import "../../styles/main-container.css";
  @import "../../styles/public.css";

  @media screen and (max-width: 750px) {
    .total-content {
      margin-top: 2%;
      width: 100%;
    }
  }

  .tooltip-text {
    text-align: center;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.84);
    text-align: center;
    font-weight: 400;
    line-height: 33px;
    margin-bottom: 60px;
  }

  .tooltip-mobile {
    text-align: center;
    font-family: PingFangSC-Regular, sans-serif;
    font-size: 24px;
    color: rgba(0, 0, 0, 0.84);
    text-align: center;
    font-weight: 400;
    line-height: 33px;
    margin-bottom: 20px;
    margin-top: 30px;
  }

  .shenpi-icon {
    font-size: 80px;
    color: rgba(10, 112, 245, 1);
    text-align: center;
  }

  .shenpi-text {
    text-align: center;
    font-family: PingFang SC, sans-serif;
    font-size: 16px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    font-weight: 500;
  }

  @media screen and (min-width: 1250px) {
    .total-content {
      margin-top: 8%;
      width: 100%;
    }
  }

  .mobile-container .mtd-form-item-label {
    font-family: PingFang SC, sans-serif;
    font-size: 16px;
    color: #333333;
    line-height: 42px;
    font-weight: 500;
  }

  .mobile-container .mtd-textarea {
    background: #F5F5F5;
    border-radius: 8px;
    border: none;
  }

  .complaint-title {
    height: 40px;
    padding: 0 6px;
    font-size: 16px;
    color: #333333;
    line-height: 42px;
    font-weight: 500;
    border-bottom: 1px solid #F5F5F5;
    margin-bottom: 16px;
  }

  @media screen and (max-width: 780px) {
    #app {
      background-color: #F5F5F5;
    }
  }

  .platform-user-dropdown .mtd-dropdown-menu-item {
    padding: 0;
  }

  .platform-user-dropdown .platform-user-info {
    padding: 8px 12px;
    border-bottom: 1px solid #f7f7f7;
    position: relative;
  }

  .platform-user-dropdown .platform-user-info .platform-user-img {
    height: 28px;
    width: 28px;
    border-radius: 50%;
    vertical-align: middle;
    position: absolute;
    top: 17px;
  }

  .platform-user-dropdown .platform-user-info .platform-user-name {
    margin-left: 36px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    display: block;
    line-height: 22px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
    cursor: pointer;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item .platform-user-dropdown-link {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) {
    height: 48px;
    line-height: 48px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) i {
    margin-right: 4px;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.87);
    vertical-align: middle;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:hover {
    background-color: #f7f7f7;
  }

  .mtd-step-main .mtd-step-main-description {
    color: rgba(0, 0, 0, .56);
    font-size: 14px;
  }
</style>
